import { TuiNotificationService } from "@taiga-ui/core";
import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../../features/auth/services/auth.service';
import { PermissionsService } from '../auth/permissions.service';
import { showUnauthorizedAlert } from '../utils/alert-helper.util';

/**
 * Allows admin or stats_editor users onto EESL parse/import routes.
 *
 * adminGuard remains the guard for admin-only routes; this guard exists so a
 * stats_editor (who can already run parse/import on the backend) is not
 * blocked from the UI that triggers it.
 */
export const statsImporterGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const alerts = inject(TuiNotificationService);
  const permissions = inject(PermissionsService);

  const isAuthenticated = authService.isAuthenticated();

  if (!isAuthenticated) {
    showUnauthorizedAlert(alerts, 'unauthenticated', {
      sessionExpiredRecently: authService.sessionExpiredRecently(),
    });
    const trigger = router.getCurrentNavigation()?.trigger;
    if (trigger === 'imperative') {
      return false;
    }
    return router.createUrlTree(['/home']);
  }

  if (permissions.canImportStats()) {
    return true;
  }

  showUnauthorizedAlert(alerts, 'forbidden');
  const trigger = router.getCurrentNavigation()?.trigger;
  if (trigger === 'imperative') {
    return false;
  }

  return router.createUrlTree(['/home']);
};
